//
//
//
//
//
//
//
//
//
//

import breadCrumbs from '~/components/common/breadCrumbs.vue'
import deepTracking from '~/components/deeptracking/deepTracking.vue'
import fundsTrends from '~/components/deeptracking/fundsTrends.vue'
import { getAppointNDay, getSeconds, getAppointNMonthHour, matomofn } from '~/assets/js/utils.js'
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    'deep-tracking': deepTracking,
    'funds-trends': fundsTrends
  },
  async asyncData ({ store, $api }) {
    const { locale = '' } = store.state
    try {
      const [{ explain = '', trendForPrice: lineList = [] }, { explain: explainScatter = '', bigTradeList: scatterList = [] }, fundsMovementData, trendForPrice] = await Promise.all([
        $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/trendForPrice' }, { symbol: 'EURUSD', num: 3, startTime: getAppointNDay('', 3), endTime: getSeconds(), apiLanguage: locale }),
        $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/bigTrade' }, { symbol: 'EURUSD', num: 3, startTime: getAppointNDay('', 3), endTime: getSeconds(), apiLanguage: locale }),
        $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/FundsMovement' }),
        $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/trendForPrice' }, { symbol: 'EURUSD', num: 3, startTime: getAppointNMonthHour('', 1), endTime: getSeconds(), apiLanguage: locale })
      ])
      return {
        explain,
        lineList,
        explainScatter,
        scatterList,
        fundsMovementData,
        trendForPrice
      }
    } catch {}
  },
  data () {
    return {
      pageEnterTime: null // 页面进入时间
    }
  },
  head () {
    return {
      title: this.$t('29347'),
      meta: [{ name: 'Description', content: this.$t('29348') }]
    }
  },
  mounted () {
    // 记录页面进入时间
    this.pageEnterTime = Date.now()
    // 监听页面关闭事件
    window.addEventListener('beforeunload', this.trackPageTime)
  },
  beforeDestroy () {
    // 移除事件监听器
    window.removeEventListener('beforeunload', this.trackPageTime)
    // 执行页面时间统计
    this.trackPageTime()
  },
  methods: {
    // 页面时间统计
    trackPageTime () {
      if (this.pageEnterTime) {
        const exitTime = Date.now()
        matomofn('Cloud_Tracking_Time', {
          af_Enter: this.pageEnterTime,
          af_Exit: exitTime
        }, this.$store.state, this.$cookies)
      }
    }
  }
}
